import React, { useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom';
import TopNavigation from '../Components/TopNavigation';
import SideNavigation from '../Components/SideNavigation';
import { useSelector } from 'react-redux';
import AccessDenied from './AccessDenied';


function Dashboard() {
    
    const navigate                    = useNavigate();
    const {user}                      = useSelector((state) => state.auth);

    useEffect(() => {

        if(!user){
            navigate("/login");
        }
    },[user, navigate])

  return (
      <div className="dashboard"> 
        {
          user &&  (user.isAdmin === true && user.approve != false)  ? (
         <div className="dashboard-orientation">
                <SideNavigation member={user} />
              
              <div className="dashboard-main">
                    
                          <TopNavigation />
                    
                      <div className="main-content-arena">
                          <Outlet />
                      </div>
              </div>
          </div>
          )
          :
            <AccessDenied />
        }       
      </div>
  )
}

export default Dashboard